import Vue from 'vue';

Vue.component('model-page-wrapper-component', {
    props: {
        initialModel: {
            type: String,
        },
        heroSection: {
            type: Object,
        },
        allPageSections: {
            type: Array,
        },
        allCompareModelsSections: {
            type: Object,
            default: () => [],
        },
        footerDisclaimers: {
            type: Object,
            default: () => ({}),
        },
        urlMappings: {
            default: () => ({}),
        },
    },

    data() {
        return {
            selectedModelPageSections: this.allPageSections,
            selectedModelHeroSection: this.heroSection,
            selectedModelFooterDisclaimer: this.footerDisclaimers || null,
            selectedCompareSectionTitle: null,
            selectedCompareSectionDownloadLabel: null,
            selectedCompareSectionBatteryAndRangeDisclaimer: null,
            allDocuments: null,
            allCompareSections: null,

            versionHandle: this.initialModel,
        };
    },

    components: {
        'model-cta-bar': () =>
            import('../async-components/async-model-new-cta-bar'),
        'model-hero': () => import('../async-components/async-model-hero'),
        'model-configurator': () =>
            import('../async-components/async-model-configurator'),
        'model-hero-like-section': () =>
            import('../async-components/async-hero-like-section'),
        'model-slider-section-with-features': () =>
            import('../async-components/async-slider-section-with-features'),
        'model-compare-section': () =>
            import('../async-components/async-model-compare-section'),
    },

    mounted() {
        // Since we no longer have multiple models in a single page,
        // we've simplified the component to work with direct values
        this.findCompareSectionHeaderAndDownloadLabels();
        this.allDocuments = this.getAssetsUrl();
        this.allCompareSections = this.getAllCompareSections();

        // Initial emit of footer disclaimer when component mounts
        EventBus.$emit('model-footer-disclaimer-changed', {
            disclaimer: this.selectedModelFooterDisclaimer,
            model: this.versionHandle,
        });
    },

    methods: {
        findCompareSectionHeaderAndDownloadLabels() {
            const compareSection =
                this.allCompareModelsSections[this.initialModel];

            if (!compareSection) return;

            this.selectedCompareSectionTitle = compareSection.headerLabel;
            this.selectedCompareSectionDownloadLabel =
                compareSection.downloadLabel;
            this.selectedCompareSectionBatteryAndRangeDisclaimer =
                compareSection.compareBlock.batteryAndRangeDisclaimer;
        },

        getAllCompareSections() {
            return Object.entries(this.allCompareModelsSections).reduce(
                (acc, [model, compareSection]) => {
                    acc[model] = compareSection
                        ? { ...compareSection, modelSlug: model }
                        : null;

                    return acc;
                },
                {},
            );
        },

        // Simplified for a single model
        getAssetsUrl() {
            const properties = this.heroSection;
            const result = {};

            result[this.initialModel] = {
                modelBrochureUrl: properties.modelBrochureUrl,
                productSheetUrl: properties.productSheetUrl,
            };

            return result;
        },
    },
});
